<template>
    <div class="page inteboscheduling" style="background-color: #ffffff">
      <el-container style="height: 100%">
        <el-header style="height: 46px">
          <van-nav-bar
            left-text="返回"
            right-text="按钮"
            left-arrow
          >
            <template #left>
              <el-switch class="myswich" @change="switchChange" :disabled="isoperation==false"
                v-model="switchValue"
                active-text="总监"
                inactive-text="操作师">
              </el-switch>
            </template>
            <template #right>
              <el-button type="primary" size="mini" v-if="isoperation && switchValue"  @click="openAddScheduling" style="margin-right: 10px">新增排班</el-button>
              <el-button type="primary" size="mini" v-if="isoperation && !switchValue"  @click="openAddLeave" style="margin-right: 10px">请假</el-button>
              <el-button-group class="mybuttongroup">
                <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="befclick"></el-button>
                <el-button  size="mini">{{curMonth}}</el-button>
                <el-button type="primary" icon="el-icon-arrow-right" size="mini" @click="afterclick"></el-button>
              </el-button-group>
            </template>
          </van-nav-bar>
        </el-header>
        <el-main style="height: 100%;">
          <el-table height="calc(100%)" ref="table" class="tableClass"  :data="schedulings" size="mini" style="text-align: center"
                    :cell-style="cellClassName" @cell-click="cellClick" :span-method="arraySpanMethod">
            <el-table-column label="员工" :key="11111" width="65" fixed align="center" prop="staffname">
            </el-table-column>
            <el-table-column width="25" :label="item.label"  align="center"  :prop="item.prop" :key="key" v-for="(item,key) in columnDatas">
              <el-table-column width="25" align="center" :label="item.week" :prop="item.prop">
                <template slot-scope="scope">
                  <div v-if="scope.row[item.prop]!=null && scope.row[item.prop]!=undefined" class="mydiv">
                    <div style="color: white;padding: 0px;margin: 0px;" v-if="scope.row[item.prop].type!=3">
                      {{scope.row[item.prop].khparentname}}
                    </div>
                    <div style="color: white;padding: 0px;margin: 0px;" v-if="scope.row[item.prop].type==1">
                      <span v-if="switchValue">{{scope.row[item.prop].operationname}}</span><span v-else>{{scope.row[item.prop].headername}}</span>
                    </div>
                    <div style="color: white;padding: 0px;margin: 0px;" v-if="scope.row[item.prop].remarks">
                      {{scope.row[item.prop].remarks}}
                    </div>
                    <div style="color: white;font-size: 10px" v-if="scope.row[item.prop].type==3">请假</div>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
      <el-dialog title="操作师请假" :visible.sync="addleaveShow" width="300px" @close="closeAddScheduling" :close-on-press-escape="false" :close-on-click-modal="false">
        <el-form ref="formoper" :model="addScheduling" label-width="80px" :rules="ruleoperation" style="padding: 0px">
          <el-form-item label="开始日期" prop="fromdate">
            <el-date-picker size="mini" :editable="false" v-model="addScheduling.fromdate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" @change="fromdateConfirm">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期" prop="todate">
            <el-date-picker size="mini" :editable="false" v-model="addScheduling.todate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" @change="todateConfirm">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作人员" prop="operation" v-show="addScheduling.type==1" @change="operationChange">
            <el-select v-model="addScheduling.operation" style="width: 100%" size="mini">
              <el-option :label="item.staffname" :value="item.staffid" :key="key" v-for="(item,key) in inteboStaffOpers"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="type">
            <el-input type="textarea" v-model="addScheduling.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addleaveShow = false" size="mini">取 消</el-button>
          <el-button type="primary" :loading="querybutton" size="mini" @click="saveOperLeave()">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="新增排班" :visible.sync="addSchedulingShow" width="300px" @close="closeAddScheduling" :close-on-press-escape="false" :close-on-click-modal="false">
        <el-form ref="form" :model="addScheduling" label-width="80px" :rules="rules" style="padding: 0px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="类型" prop="type">
                <el-radio-group v-model="addScheduling.type" @change="typeChange">
                  <el-radio :label="1" :disabled="typeDisabled">启动</el-radio>
                  <el-radio :label="2" :disabled="typeDisabled">培训</el-radio>
                  <el-radio :label="3" :disabled="typeDisabled">请假</el-radio>
                  <el-radio :label="4" :disabled="typeDisabled">卖券</el-radio>
                  <el-radio :label="5" :disabled="typeDisabled">驻店</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="客户门店" prop="khs" v-show="addScheduling.type!=3">
                    <el-cascader size="mini" v-model="addScheduling.khs" ref="khs" style="width: 100%"
                             :options="inteboStoreSturct" class="cascader" filterable :props="props" clearable @change="khsChange"></el-cascader>
              </el-form-item>
              <el-form-item label="开始日期" prop="fromdate">
                <el-date-picker size="mini" :editable="false" v-model="addScheduling.fromdate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" @change="fromdateConfirm">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" prop="todate">
                <el-date-picker size="mini" :editable="false" v-model="addScheduling.todate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" @change="todateConfirm">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="总监" prop="header" v-if="addScheduling.type!=5">
                <el-select v-model="addScheduling.header"  style="width: 100%" size="mini" @change="headerChange">
                  <el-option :label="item.staffname" :value="item.staffid" :key="key" v-for="(item,key) in inteboStaffZjs"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作人员" prop="operationdata" v-show="addScheduling.type==1 || addScheduling.type==2 || addScheduling.type==5" @change="operationChange">
                <el-select v-model="addScheduling.operationdata" style="width: 100%" size="mini" multiple>
                  <el-option :label="item.staffname" :value="item.staffid" :key="key" v-for="(item,key) in inteboStaffOpers"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="type">
                <el-input type="textarea" v-model="addScheduling.remarks"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addSchedulingShow = false" size="mini">取 消</el-button>
          <el-button type="primary" :loading="querybutton" size="mini" @click="saveInteboScheduling()">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="已经排班信息" :visible.sync="isRealShow" width="300px">
        <el-table :show-header="false" border :data="inteboStaffIsScheduLings" size="mini" style="text-align: center">
          <el-table-column>
            <template slot-scope="scope">
              <el-form label-width="60px" label-position="left" class="demo">
                <el-form-item label="总监">
                  <span>{{ scope.row.headername }}</span>
                </el-form-item>
                <el-form-item label="日期">
                  <span>{{ scope.row.fromdate }}到{{ scope.row.todate }}</span>
                </el-form-item>
                <el-form-item label="门店">
                  <span>
                    <el-tag type="danger" v-if="scope.row.type==1">启动</el-tag>
                    <el-tag v-if="scope.row.type==2">培训</el-tag>
                    <el-tag type="warning" v-if="scope.row.type==3">请假</el-tag>
                    <el-tag color="blue" v-if="scope.row.type==4">卖券</el-tag>
                    <el-tag color="blue" v-if="scope.row.type==5">驻店</el-tag>
                    {{ scope.row.khparentname }}
                  </span>
                </el-form-item>
                <el-form-item label="操作师">
                  <span>{{ scope.row.operationname }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancalIsRealScHeduling" size="mini">取 消</el-button>
          <el-button type="primary" :loading="querybutton" size="mini" @click="deleteInteboScheduling">是否删除这些排班</el-button>
        </div>
      </el-dialog>

      <el-dialog title="排班详情" :visible.sync="schedulingDetalShow" width="300px">
        <el-form label-width="60px" label-position="left" class="demo" style="padding: 20px">
          <el-form-item label="操作师" v-if="showScheduling.type==3 && !switchValue">
            <span>{{ showScheduling.operationname }}</span>
          </el-form-item>
          <el-form-item label="总监" v-else>
            <span>{{ showScheduling.headername }}</span>
          </el-form-item>
          <el-form-item label="日期">
            <span>{{ showScheduling.fromdate }}到{{ showScheduling.todate }}</span>
          </el-form-item>
          <el-form-item label="门店">
                  <span>
                    <el-tag type="danger" v-if="showScheduling.type==1">启动</el-tag>
                    <el-tag v-if="showScheduling.type==2">培训</el-tag>
                    <el-tag type="warning" v-if="showScheduling.type==3">请假</el-tag>
                    <el-tag color="blue" v-if="showScheduling.type==4">卖券</el-tag>
                      <el-tag color="blue" v-if="showScheduling.type==5">驻店</el-tag>
                    <span v-if="showScheduling.type!=3">{{ showScheduling.khparentname }}</span>
                  </span>
          </el-form-item>
          <el-form-item label="操作师" v-if="showScheduling.type==1">
            <span>{{ showScheduling.operationname }}</span>
          </el-form-item>
          <el-form-item label="备注">
            <span>{{ showScheduling.remarks }}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="schedulingDetalShow=false" size="mini">取 消</el-button>
          <el-button type="danger" v-if="isoperation"  size="mini" @click="cancelInteboScheduling(showScheduling)">取消排版</el-button>
          <el-button type="primary" v-if="isoperation" size="mini" @click="openupdate(showScheduling)">修改</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            addleaveShow: false,
            switchValue: true,
            typeDisabled: false,
            showScheduling: {},
            schedulingDetalShow: false,
            isRealShow: false,
            props: {checkStrictly: true},
            querybutton: false,
            todateshow: false,
            show: false,
            ruleoperation: {
                fromdate: [
                    {required: true, message: "请选择开始日期", trigger: 'change'},
                ],
                todate: [
                    {required: true, message: "请选择结束日期", trigger: 'change'},
                ],
                operation: [
                    {required: true, message: "请选择操作师", trigger: 'change'},
                ],
            },
            rules: {
                fromdate: [
                    {required: true, message: "请选择开始日期", trigger: 'change'},
                ],
                todate: [
                    {required: true, message: "请选择结束日期", trigger: 'change'},
                ],
                /*header:[
          { required: true, message: "请选择总监", trigger: 'change' },
        ],*/
            },
            inteboscheduling: {
                khs: [],
                storeid: "",
                sysbillid: "",
                month: "",
                accountdate: "",
                khstoreid: "",
                khparentid: "",
                header: "",
                type: 1,
                remarks: "",
                operation: "",
                createdate: "",
                fromdate: "",
                todate: "",
                operationdata: [],
            },
            addScheduling: {},
            addSchedulingShow: false,
            columnDatas: [],
            schedulings: [],
            curMonth: this.$moment().format("YYYY-MM"),
            chooseCells: [],
            inteboStaffZjs: [],
            inteboStaffOpers: [],
            inteboStoreSturct: [],
            inteboStaffIsScheduLings: [],
            isoperation: false,
            isshowall: false,
        }
    },
    created() {
        let posid = localStorage.getItem("posid");
        let staffid = localStorage.getItem("staffid");
        if (posid == "838b09f8ae0c4a3c8646705e099cd385"
            || staffid == "7ca02244b4094f45801c64646a160a5a"
            || staffid == "2ef499fe5f6a452c9d3a69637a1bb82e" || posid == "9c2a606def0f492b87e7abbeecd1670e") {
            this.isoperation = true;
            this.isshowall = true;
        }
        if (staffid == "c841bb8c5f3c476f85b98da5ef21cf08") {
            this.isshowall = true;
        }

        if (posid == "10c1b4e494ea4b99950d0d0f158ef5fa" || posid=="ce8c225692864bacab3ebf24575e3141") {
            this.switchValue = false;
            this.getMonthDays(2);
        } else {
            this.getMonthDays(1);
        }
        this.getInteboStaffByZj();
        this.getInteboStaffByOper();
        this.getInteboStoreSturct();

        //let staffid = this.$getUrlKey("staffid");
        //this.getCorpUserInfo(staffid);

        /*let userId = this.$getUrlKey("userId");
    let code = this.$getUrlKey("code");
    if (userId || code) {
      if (userId) {
        this.getCorpUserInfo(userId);
      }
    } else {
        window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getInteboCorpCode?state="+encodeURIComponent("intebo.shmiaojie.cn/#/inteboschedulinginfo");
      //window.location.href="http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechat/getCorpidCode?state=7";
      //window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCode?state=9";
    }*/
        /*this.getMonthDays();
            this.getInteboStaffByZj();
            this.getInteboStaffByOper();
            this.getInteboStoreSturct();*/

    },
    updated() {
        this.$nextTick(() => {
            this.$refs['table'].doLayout();
        });
    },
    methods: {
        openAddLeave() {
            this.addleaveShow = true;
            this.addScheduling = this.$copy(this.inteboscheduling);
            if (this.chooseCells != null && this.chooseCells.length > 0) {
                this.chooseCells.sort(this.sortByArr(["accountdate"], true));
                this.addScheduling.fromdate = this.$moment(this.chooseCells[0].accountdate).format("YYYY-MM-DD");
                this.addScheduling.todate = this.$moment(this.chooseCells[this.chooseCells.length - 1].accountdate).format("YYYY-MM-DD");
                this.addScheduling.operation = this.chooseCells[0].staffid;
            }
        },
        getCorpUserInfo(staffid) {
            this.$post("wechat/getInteboCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        //如果钉钉没找到就关闭页面
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        if (data.staff.posid == "838b09f8ae0c4a3c8646705e099cd385"
                            || data.staff.staffid == "7ca02244b4094f45801c64646a160a5a"
                            || data.staff.staffid == "2ef499fe5f6a452c9d3a69637a1bb82e" || data.staff.posid == "9c2a606def0f492b87e7abbeecd1670e") {
                            this.isoperation = true;
                            this.isshowall = true;
                        }

                        if (data.staff.staffid == "c841bb8c5f3c476f85b98da5ef21cf08") {
                            this.isshowall = true;
                        }

                        if (data.staff.posid == "10c1b4e494ea4b99950d0d0f158ef5fa" || data.staff.posid=="ce8c225692864bacab3ebf24575e3141") {
                            this.switchValue = false;
                            this.getMonthDays(2);
                        } else {
                            this.getMonthDays(1);
                        }
                        this.getInteboStaffByZj();
                        this.getInteboStaffByOper();
                        this.getInteboStoreSturct();
                    }
                }
            });
        },
        switchChange(val) {
            this.chooseCells = [];
            if (val) {
                this.getInteboSchedulingByAccountdate(1);
            } else {
                this.getInteboSchedulingByAccountdate(2);
            }
        },
        befclick() {
            this.chooseCells = [];
            this.curMonth = this.$moment(this.curMonth + "-01").add(-1, 'month').format('YYYY-MM');
            if (this.switchValue) {
                this.getMonthDays(1);
            } else {
                this.getMonthDays(2);
            }
            //this.getInteboSchedulingByAccountdate(1);
        },
        afterclick() {
            this.chooseCells = [];
            this.curMonth = this.$moment(this.curMonth + "-01").add(1, 'month').format('YYYY-MM');
            if (this.switchValue) {
                this.getMonthDays(1);
            } else {
                this.getMonthDays(2);
            }
            //this.getInteboSchedulingByAccountdate(1);
        },
        openupdate(obj) {
            this.schedulingDetalShow = false;
            this.addSchedulingShow = true;
            this.addScheduling = this.$copy(obj);
            if (this.addScheduling.type == 1) {
                this.props = {checkStrictly: true};
                this.addScheduling.khs = this.addScheduling.khs[0].split(",");
            } else if (this.addScheduling.type == 2 || this.addScheduling.type == 4 || this.addScheduling.type==5) {
                this.props = {multiple: true, checkStrictly: true};
                let khsData = [];
                if (this.addScheduling.khs != null && this.addScheduling.khs.length > 0) {
                    for (let val of this.addScheduling.khs) {
                        let array = val.split(",");
                        khsData.push(array);
                    }
                    this.addScheduling.khs = [];
                    this.addScheduling.khs = khsData;
                    //console.log(this.addScheduling.khs);
                }
            }
            if (this.addScheduling.operation) {
                //this.addScheduling.operationdata=[];
                this.$set(this.addScheduling, "operationdata", []);
                this.addScheduling.operationdata = this.addScheduling.operation.split(",");
            }
            //console.log(this.addScheduling);
        },
        cancelInteboScheduling(obj) {
            this.$confirm('您确定要取消该排班吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post("inteboScheduling/cancelInteboScheduling", {sysbillid: obj.sysbillid}).then(res => {
                    if (res.sucess) {
                        this.$message({message: '取消排版成功', type: 'success'});
                        this.schedulingDetalShow = false;
                        if (this.switchValue) {
                            this.getInteboSchedulingByAccountdate(1);
                        } else {
                            this.getInteboSchedulingByAccountdate(2);
                        }
                    }
                });
            });
        },
        closeAddScheduling() {
            this.chooseCells = [];
            for (let val of this.schedulings) {
                for (let idx in this.columnDatas) {
                    this.$set(val, "ishas" + this.columnDatas[idx].prop, 0);
                }
            }
        },
        spanMethod() {
            let spanarry = [];
            let rowindex = 0;
            for (let val of this.schedulings) {
                let index = -1;
                let count = 0;
                for (let idx in this.columnDatas) {
                    if (val[this.columnDatas[idx].prop]) {
                        if (index < 0) {
                            index = parseInt(idx) + 1;
                        }
                        let nextidx = parseInt(idx) + 1;
                        if (this.columnDatas[nextidx] && val[this.columnDatas[nextidx].prop] && val[this.columnDatas[idx].prop].sysbillid == val[this.columnDatas[nextidx].prop].sysbillid) {
                            count++;
                        } else {
                            count++;
                            let array = new Object();
                            array.rowindex = rowindex;
                            array.index = index;
                            array.count = count;
                            spanarry.push(array);
                            count = 0;
                            index = -1;
                        }
                    }
                }
                rowindex++;
            }
            return spanarry;
        },

        arraySpanMethod({row, column, rowIndex, columnIndex}) {
            if (column.property == "staffname") {
                return;
            }
            if (row[column.property]) {
                if (parseInt(row[column.property].month) > 0) {
                    return {rowspan: 1, colspan: row[column.property].month};
                } else {
                    return {rowspan: 0, colspan: 0};
                }
            }
        },
        cancalIsRealScHeduling() {
            this.isRealShow = false;
            this.addScheduling.header = "";
            this.addScheduling.operation = "";
        },
        deleteInteboScheduling() {
            this.$confirm('确定要删除这些排版信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let sysbillids = [];
                for (let val of this.inteboStaffIsScheduLings) {
                    sysbillids.push(val.sysbillid);
                }
                this.$postw("inteboScheduling/deleteInteboScheduling", sysbillids).then(res => {
                    if (res.sucess) {
                        this.$message({message: '删除成功', type: 'success'});
                        this.isRealShow = false;
                    }
                });
            });
        },
        operationChange() {
            this.getInteboStaffSchedulingByStaffAccountdate(2);
        },
        headerChange() {
            this.getInteboStaffSchedulingByStaffAccountdate(1);
        },
        getInteboStaffSchedulingByStaffAccountdate(type) {
            if (this.addScheduling.fromdate && this.addScheduling.todate) {
                let staffid = "";
                if (type == 1) {
                    if (this.addScheduling.header) {
                        staffid = this.addScheduling.header;
                    }
                } else if (type == 2) {
                    if (this.addScheduling.operation) {
                        staffid = this.addScheduling.operation;
                    }
                }
                if (staffid) {
                    this.$post("inteboScheduling/getInteboStaffSchedulingByStaffAccountdate",
                        {
                            staffid: staffid, fromdate: this.addScheduling.fromdate, todate: this.addScheduling.todate,
                            type: type, sysbillid: this.addScheduling.sysbillid
                        }).then(res => {
                        if (res.sucess) {
                            this.inteboStaffIsScheduLings = res.object;
                            if (this.inteboStaffIsScheduLings != null && this.inteboStaffIsScheduLings.length > 0) {
                                this.isRealShow = true;
                            }
                        }
                    });
                }
            }

        },
        typeChange() {
            if (this.addScheduling.type == 1) {
                this.props = {checkStrictly: true};
            } else if (this.addScheduling.type == 2 || this.addScheduling.type == 4 || this.addScheduling.type==5) {
                this.props = {multiple: true, checkStrictly: true};
            }
            this.addScheduling.khs = [];
        },
        khsChange(val) {
            //console.log(val);
            if (this.addScheduling.type == 1) {
                this.$refs["khs"].dropDownVisible = false;
            }
        },
        saveOperLeave() {
            this.$refs["formoper"].validate((valid) => {
                if (valid) {
                    this.addScheduling.type = 3;
                    this.$postw("inteboScheduling/saveInteboScheduling", this.addScheduling).then(res => {
                        if (res.sucess) {
                            this.$message({message: '保存成功', type: 'success'});
                            this.addleaveShow = false;
                            this.getInteboSchedulingByAccountdate(2);
                        }
                    });
                }
            });
        },
        saveInteboScheduling() {
            console.log(this.addScheduling);
            if (this.addScheduling.type != 3) {
                if (this.addScheduling.khs == null || this.addScheduling.khs.length < 1) {
                    this.$message({message: '请选择门店信息', type: 'error'});
                    return;
                }
            }
            /*if(this.addScheduling.type==1){
        if(this.addScheduling.operationdata==null || this.addScheduling.operationdata.length<1){
          this.$message({message: '请选择操作人员', type: 'error'});
          return;
        }
      }*/

            //console.log(this.addScheduling.khs);

            this.addScheduling.month = this.curMonth;
            let khparentid = "";
            let khstoreid = "";
            let parentarray = [];
            let storearry = [];
            if (this.addScheduling.type == 1) {
                khparentid = this.addScheduling.khs[0];
                khstoreid = this.addScheduling.khs[1];
            } else if (this.addScheduling.type == 2 || this.addScheduling.type == 4 || this.addScheduling.type==5) {
                for (let val of this.addScheduling.khs) {
                    //console.log(val);
                    if (val[0]) {
                        parentarray.push(val[0]);
                    }

                    if (val[1]) {
                        storearry.push(val[1]);
                    }

                    /*if (!khparentid) {
            khparentid = val[0];
          } else {
            khparentid = khparentid + "," + val[0];
          }

          if (!khstoreid) {
            khstoreid = val[1];
          } else {
            khstoreid = khstoreid + "," + val[1];
          }*/
                }
                parentarray = this.$delRepeat(parentarray);
                storearry = this.$delRepeat(storearry);
                khparentid = parentarray.join();
                khstoreid = storearry.join();
            }

            this.addScheduling.khparentid = khparentid;
            this.addScheduling.khstoreid = khstoreid;
            this.addScheduling.khs = [];
            if (this.addScheduling.operationdata != null && this.addScheduling.operationdata.length > 0) {
                this.addScheduling.operation = this.addScheduling.operationdata.join(",");
            }

            this.$postw("inteboScheduling/saveInteboScheduling", this.addScheduling).then(res => {
                if (res.sucess) {
                    this.$message({message: '保存成功', type: 'success'});
                    this.addSchedulingShow = false;
                    this.getInteboSchedulingByAccountdate(1);
                }
            });
        },
        getInteboStoreSturct() {
            this.$post("inteboScheduling/getInteboStoreSturct").then(res => {
                if (res.sucess) {
                    this.inteboStoreSturct = res.object;
                }
            });
        },
        getInteboStaffByZj() {
            this.$post("inteboScheduling/getInteboStaffByZj").then(res => {
                if (res.sucess) {
                    this.inteboStaffZjs = res.object;
                }
            });
        },
        getInteboStaffByOper() {
            this.$post("inteboScheduling/getInteboStaffByOper").then(res => {
                if (res.sucess) {
                    this.inteboStaffOpers = res.object;
                }
            });
        },
        todateConfirm(date) {
            this.todateshow = false;
            this.addScheduling.todate = this.$moment(date).format("YYYY-MM-DD");
            if (this.switchValue) {
                this.getInteboStaffSchedulingByStaffAccountdate(1);
            } else {
                this.getInteboStaffSchedulingByStaffAccountdate(2);
            }
        },
        fromdateDateShow() {
            this.show = true;
        },
        fromdateConfirm(date) {
            this.show = false;
            this.addScheduling.fromdate = this.$moment(date).format("YYYY-MM-DD");
            if (this.switchValue) {
                this.getInteboStaffSchedulingByStaffAccountdate(1);
            } else {
                this.getInteboStaffSchedulingByStaffAccountdate(2);
            }
        },
        openAddScheduling() {
            this.addSchedulingShow = true;
            this.addScheduling = this.$copy(this.inteboscheduling);
            if (this.chooseCells != null && this.chooseCells.length > 0) {
                this.chooseCells.sort(this.sortByArr(["accountdate"], true));
                this.addScheduling.fromdate = this.$moment(this.chooseCells[0].accountdate).format("YYYY-MM-DD");
                this.addScheduling.todate = this.$moment(this.chooseCells[this.chooseCells.length - 1].accountdate).format("YYYY-MM-DD");
                this.addScheduling.header = this.chooseCells[0].staffid;
                //console.log(this.chooseCells[0]);
                if (this.addScheduling.header == "74363d775896405da10e88e2245ede58" || this.addScheduling.header == "c0d8cc53b4a140b7bb6c4128970ab7e6"
                    || this.chooseCells[0].posid == "af74bad7c517456a95158a1ae5110f3f") {
                    this.addScheduling.type = 2;
                    this.typeDisabled = true;
                    this.props = {multiple: true, checkStrictly: true};
                } else if (this.addScheduling.header == "542479a3c4ce47658c678d7c56adb708") {
                    this.addScheduling.type = 4;
                    this.typeDisabled = true;
                    this.props = {multiple: true, checkStrictly: true};
                } else {
                    this.addScheduling.type = 1;
                    this.typeDisabled = false;
                    this.props = {checkStrictly: true};
                }
            } else {
                this.addScheduling.type = 1;
                this.typeDisabled = false;
                this.props = {checkStrictly: true};
            }
            //this.getInteboStaffSchedulingByStaffAccountdate(1);
        },
        sortByArr(arr, rev) {
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                for (var i = 0; i < arr.length; i++) {
                    let attr = arr[i]
                    if (a[attr] != b[attr]) {
                        if (a[attr] > b[attr]) {
                            return rev * 1;
                        } else {
                            return rev * -1;
                        }
                    }
                }
            }
        },
        cellClick(row, column, event, cell) {
            let columname = column.property;

            if (row[columname]) {
                if (row[columname].sysbillid) {
                    this.schedulingDetalShow = true;
                    this.showScheduling = row[columname];
                    return;
                }
            }

            if (this.isoperation == false) {
                return;
            }

            //操作师只能看不能操作
            /*if(this.switchValue==false){
        return;
      }*/

            if (columname == "staffname") {
                return;
            }
            if (this.chooseCells != null && this.chooseCells.length > 0) {
                let staffid = this.chooseCells[0].staffid;
                if (staffid != row.staffid) {
                    return;
                }
            }
            if (row["ishas" + column.property] == 1) {
                this.$set(row, "ishas" + columname, 0);
                for (let i = this.chooseCells.length - 1; i >= 0; i--) {
                    if (this.chooseCells[i].staffid == row.staffid && this.chooseCells[i].accountdate == columname.substring(3)) {
                        this.chooseCells.splice(i, 1);
                    }
                }
            } else {
                this.$set(row, "ishas" + columname, 1);
                let chooseobj = new Object();
                chooseobj.staffid = row.staffid;
                chooseobj.accountdate = columname.substring(3);
                //console.log(row);
                chooseobj.posid = row.posid;
                this.chooseCells.push(chooseobj);
            }
            //this.$refs["table"].doLayout();
        },
        cellClassName({row, column, rowIndex, columnIndex}) {
            let columnname = column.property;
            if (columnname == "staffname") {
                return;
            }
            if (row[column.property]) {
                if (row[column.property].type == 1) {
                    return {
                        background: 'red'
                    }
                } else if (row[column.property].type == 2) {
                    //console.log(row)
                    if (row.staffid == "542479a3c4ce47658c678d7c56adb708") {
                        return {
                            background: '#0dcaf0'
                        }
                    } else {
                        return {
                            background: '#409EFF'
                        }
                    }
                } else if (row[column.property].type == 3) {
                    return {
                        background: '#f4984e'
                    }
                } else if (row[column.property].type == 4) {
                    return {
                        background: 'blue'
                    }
                }
                else if (row[column.property].type == 5) {
                    return {
                        background: '#67c23a'
                    }
                }
            }
            if (row["ishas" + column.property] == 1) {
                return {
                    background: '#317eb0'
                }
            }
        },
        tableRowClassName({row, rowIndex}) {
            return '';
        },
        getInteboSchedulingByAccountdate(type) {
            this.$post("inteboScheduling/getInteboSchedulingByAccountdate", {
                month: this.curMonth,
                type: type
            }).then(res => {
                this.schedulings = [];

                let staffid = localStorage.getItem("staffid");
                let posid = localStorage.getItem("posid");
                if (this.isshowall == false) {
                    if (res.object != null && res.object.length > 0) {
                        for (let val of res.object) {
                            if (staffid == val.staffid) {
                                this.schedulings.push(val);
                            } else if (posid == "4dca622426e944fb8d840c9b03b9cfc8") {
                                if (val.posid == "af74bad7c517456a95158a1ae5110f3f") {
                                    this.schedulings.push(val);
                                }
                            }

                            if(staffid=="b40eefeb44e9498ba53dfaca687fa55b"){
                                if("1d2c654b44754d6dbdc820f881d11a4b"==val.posid
                                    || "4629f01b44ba4bc7808c3ee32a29cd2a"==val.posid
                                    || "4dca622426e944fb8d840c9b03b9cfc8"==val.posid
                                    || "af74bad7c517456a95158a1ae5110f3f"==val.posid){
                                    this.schedulings.push(val);
                                }
                            }
                        }
                    }
                } else {
                    this.schedulings = res.object;
                }
                for (let idx in this.schedulings) {
                    if (this.schedulings[idx].inteboSchedulings != null && this.schedulings[idx].inteboSchedulings.length > 0) {
                        for (let val of this.schedulings[idx].inteboSchedulings) {
                            if (val.accountdate) {
                                let accountdates = val.accountdate.split(",");
                                let index = 0;
                                for (let date of accountdates) {
                                    let newVal = this.$copy(val);
                                    if (index > 0) {
                                        newVal.month = 0;
                                    } else {
                                        newVal.month = parseInt(newVal.month);
                                    }
                                    let columnname = "day" + date.replace(new RegExp("-", "gm"), "");
                                    this.$set(this.schedulings[idx], columnname, newVal);
                                    index++;
                                }
                            }
                            //this.$set(this.schedulings[idx],"day"+val.accountdate.replaceAll("-","")+"operation");
                        }
                    }
                }
            })
        },
        getMonthDays(type) {
            this.columnDatas = [];
            this.$post("inteboScheduling/getMonthDays", {month: this.curMonth}).then(res => {
                this.columnDatas = res.object;
                this.getInteboSchedulingByAccountdate(type);
            });
        }
    }
}
</script>

<style style lang="scss" rel="stylesheet/scss">
.inteboscheduling .el-main{
  padding:0px;
}

.page .el-table{
  font-size:8px;
}

.el-table span{
  -webkit-transform: scale(0.5);
  font-size:8px;
}


.page .el-table--enable-row-hover .el-table__body tr:hover{

}

.page .el-table__body tr.current-row>td{
  background-color: #69A8EA !important;
  color: #fff;
}

.page .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color:white;
}


.rgb196{
  background: white;
}
.bacColor317eb0{
  background: #317eb0;
}
.bacColorf4984e {
  background: #f4984e;
}

.backColor67c23a{
    background: #67c23a;
}

.red{
  background: red;
}

 .tableClass .cell{
  padding: 0!important;
  height: 36px;
  line-height:1;
}

 .page .el-dialog__body{
   padding: 0px;
 }


 .page .el-dialog__title{
   font-size:14px;
   line-height:14px;
 }

 .page .el-radio{
   margin-right:5px;
 }

 .page .el-radio__label{
   padding-left:5px;
 }

 .page .el-form-item{
   margin-bottom:0px
 }

.el-popper .el-radio__inner{
   width:24px;
   height:24px;
 }


.el-popper .el-checkbox__inner{
  width:24px;
  height:24px;
}

.el-message-box__wrapper .el-message-box{
  width: 320px;
}

.page .el-header{
  padding: 0px;
}

.mybuttongroup .el-button--mini, .el-button--mini.is-round{
  padding:5px 10px;
}

.van-nav-bar__right .el-button--mini, .el-button--mini.is-round{
  padding:5px 10px;
}

.myswich .el-switch__label *{
  font-size: 10px;
}

.available .el-date-table{
  font-size:14px;
}


.mydiv div{
        font-size: 12px;
        transform: scale(0.9);
        line-height: 12px;
}


.el-table__body {
    width: 100%;
    table-layout: fixed !important;
}


</style>



// WEBPACK FOOTER //
// src/page/intebo/inteboscheduling/inteboschedulinginfo.vue